export function pathnameToTarget(pathname) {
  // eslint-disable-next-line no-unused-vars
  const [ignore, cohortId, deploymentId, ...rest] = pathname.split('/');
  const target = {
    cohortId,
    deploymentId,
  };

  if (rest && rest.length > 0) {
    target.id = rest.pop();
    target.simplifiedAncestry = rest.reverse();
  }

  return target;
}

export function targetToPathname(target) {
  const toURL = (...arr) => `/${arr.join('/')}`;

  if (!target.id) {
    return toURL(
      target.cohortId,
      target.deploymentId
    );
  }

  if (target.type === 'ACTIVITY' || !target.ancestry) {
    return toURL(
      target.cohortId,
      target.deploymentId,
      target.id
    );
  }

  const firstActivity = target.ancestry.find(({ elementType }) => elementType === 'ACTIVITY');
  const parent = target.ancestry.find(({ elementType }) => elementType !== 'PATHWAY');

  if (target.type === 'INTERACTIVE') {
    return toURL(
      target.cohortId,
      target.deploymentId,
      firstActivity.elementId,
      target.id
    );
  }

  if (parent.elementType === 'INTERACTIVE') {
    return toURL(
      target.cohortId,
      target.deploymentId,
      firstActivity.elementId,
      parent.elementId,
      target.id
    );
  }

  return toURL(
    target.cohortId,
    target.deploymentId,
    firstActivity.elementId,
    target.id
  );
}

export function subTargetToSearchPart(subTarget) {
  if (!subTarget || Object.keys(subTarget).length === 0) {
    return '';
  }

  const stringify = (prop) => typeof prop === 'object'
    ? JSON.stringify(prop)
    : prop.toString();

  const searchPart = Object.entries(subTarget)
    .map(([key, value]) => `${key}=${encodeURIComponent(stringify(value))}`)
    .join('&');

  return `?${searchPart}`;
}

export function searchPartToSubTarget(search) {
  if (!search || search.length === 0) {
    return undefined;
  }

  return search
    .substring(1)
    .split('&')
    .reduce((acc, val) => ({
      ...acc,
      [val.split('=')[0]]: decodeURIComponent(val.split('=')[1]),
    }), {});
}
